import { CollaborativeAreaType } from '@/shared/enums/CollaborativeAreaType';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { itiHttpService, itiSignalRService, i18n, itiMessageService } from '@/iti-core-vue';
import DxButton from 'devextreme-vue/button';
import DxDataGrid, { DxColumn, DxPaging, DxScrolling } from 'devextreme-vue/data-grid';
import offerDemandModule from '@/store/modules/offer-demand.module';
import collaborativeAreaModule from '@/store/modules/collaborative-area.module';
import { CollaborativeAreaMember } from '@/shared/dtos/collaborative-area-member';
import { Matching } from '@/shared/dtos/matching';
import { CollaborativeArea } from '@/shared/dtos/collaborative-area';

@Component({
    components: {
        DxButton,
        DxDataGrid,
        DxColumn,
        DxPaging,
    },
})
export default class MatchingOfferDemand extends Vue {

    @Prop() public matching!: Matching
    @Prop() public pos!: number
    @Prop() public isOffer!: Boolean
    @Prop() public name!: string
    public pageSize: number = 10;

    public get matchings() {
        return offerDemandModule.responseAlgorithmList[this.pos];
    }

    public get fakeData() {
        return offerDemandModule.fakeData;
    }

    public get offerDemand() {
        return offerDemandModule.offerDemand;
    }

    public get myId() {
        return collaborativeAreaModule.myId;
    }

    public get collaborativeArea() {
        return collaborativeAreaModule.selectedCollaborativeArea;
    }


    public interested() {
        this.matching.myInteresed = true;
        offerDemandModule.interested([this.matching.algorithmId, this.isOffer]);

    }

    public information(e: boolean) {
        if (e) {
            return "sí";
        } else {
            return "no";
        }
    }

    public createArea() {
        var collabArea: CollaborativeArea = new CollaborativeArea();
        this.addOwnersToArea(collabArea);
        collabArea.name = "Area colaborativa " + this.name;
        collabArea.description = "Area colaborativa " + this.name;
        collabArea.type = CollaborativeAreaType.PrivateArea;
        collaborativeAreaModule.saveCollaborativeArea(collabArea)
            .then(() => {
                offerDemandModule.markCollaborativeAreaCreated(this.matching.algorithmId)
                    .then(() => {
                        this.$router.push({ name: 'CollaborativeAreaDetails', params: { id: collaborativeAreaModule.selectedCollaborativeArea.id.toString() } });
                    })
                    .catch(() => {
                        itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
                    });
            })
            .catch(() => {
                itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
            });
    }

    public addOwnersToArea(collabArea: CollaborativeArea) {
        collabArea.users = [];
        /*var owner1: CollaborativeAreaMember = new CollaborativeAreaMember();
        owner1.id = 0;
        owner1.roleId = 4;
        owner1.userId = this.matching.anotherInteresedId;
        collabArea.users.push(owner1);*/
        var owner2: CollaborativeAreaMember = new CollaborativeAreaMember();
        owner2.id = 0;
        owner2.roleId = 4;
        owner2.userId = this.matching.myId;
        collabArea.users.push(owner2);
    }

    public accessArea() {
        this.$router.push({ name: 'CollaborativeAreaDetails', params: { id: this.matching.collaborativeAreaId.toString() } });
    }

    public openDocument(value: string) {
        window.open(value);
    }

}
